import React, { useState } from 'react';

import { IInvitedFragment } from './interface';

import RegistrationForm from './RegistrationForm';
import RegistrationSuccess from './RegistrationSuccess';
import Login from 'pages/Login';
import { PageViewTracker } from 'components/ApplicationInsights/pageViewTracker';

/**
 *
 * @param step Number of form step
 * @param setStep Function to change form step
 */
const StepController: React.FC<IInvitedFragment> = ({
  step,
  setStep,
  ...props
}) => {
  switch (step) {
    case 0:
      return <RegistrationForm {...props} step={step} setStep={setStep} />;
    case 1:
      return <RegistrationSuccess {...props} step={step} setStep={setStep} />;
    default:
      return null;
  }
};

/**
 * Main content
 */
const Invited: React.FC = (props) => {
  const [registrationStep, setRegistrationStep] = useState(0);

  return (
    <Login noBottomLogo>
      <PageViewTracker />
      <StepController
        {...props}
        step={registrationStep}
        setStep={setRegistrationStep}
      />
    </Login>
  );
};

export default Invited;
